<template>
  <div class="white pa-4">
    <v-row>
      <v-col cols="12" md="6">
        <v-radio-group v-model="dates.typeData" class="ma-3" @change="handleCashierCutTypeDataChange">
          <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
          <v-radio
            label="Ver reporte con datos de producción"
            value="01"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <template v-if="reportModule && isCarsem">
      <v-row class="my-2">
        <v-col cols="12" class="d-flex justify-end">
          <v-btn class="btn-save mr-3" @click="printReport" small>
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <block v-if="loading"></block>
    <div>
      <v-tabs v-model="tab">
        <v-tab v-if="canViewCashierReports" href="#1">Ver reporte general</v-tab>
        <v-tab v-if="canViewCashierReports" href="#2">Ver reporte detallado</v-tab>
        <v-tab href="#3">Control de caja</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-if="canViewCashierReports" value="1">
          <br />
          <v-row class="my-4 mb-2 cashier-cut-filter-row">
            <v-col cols="12" md="3">
              <v-select
                v-model="dates.typeDate"
                :items="dateTypeOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                label="Tipo de fecha"
                @change="handleCashierCutDateTypeChange('general', $event)"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="selectedCashierCutUserId"
                :items="cashierCutUserOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                label="Usuario"
                @change="handleCashierCutUserChange"
              />
            </v-col>
            <v-col cols="12" md="6">
              <date-filter
                @datesSelected="setDates"
                :search="{ typeData: dates.typeData, typeDate: dates.typeDate, filter: dates.filter }"
                class="cashier-cut-date-filter"
                @filtered-data="dateFilterHandler"
                @filtered-loading="loading = $event"
                :dataToFilter="cashierCut"
                :filterEndpoint="$API.invoices.getCashierCutFilteredByDates"
                :isFilteredByOutsource="false"
              />
            </v-col>
          </v-row>
          <GeneralFilter
            class="backgroundGlobal border-boxGlobal"
            :search="dates"
            :breakline="true"
            :filterEndpoint="$API.invoices.getCashierCutFiltered"
            @emptyFilter="getCashierCut"
            @filtered="filterHandler"
          >
            <DxDataGrid
              class="isScrolledByGeneralFilter"
              :data-source="cashierCut"
              @exporting="onExporting"
              :paging="{ enabled: false }"
              style="max-height: 600px"
            >
              <DxExport :enabled="true" />
              <!--DxPaging :page-size="10" /-->
              <DxColumn data-field="InvoiceDate" caption="Fecha"></DxColumn>
              <DxColumn data-field="UserName" caption="Usuario"></DxColumn>
              <DxColumn
                data-field="FullName"
                caption="Nombre de usuario"
              ></DxColumn>
              <DxColumn
                data-field="DescPaymentType"
                caption="Tipo de pago"
              ></DxColumn>
              <!--template #desc-paymenttype="{data}">
                                {{ data.data.DescPaymentType != null ? data.data.DescPaymentType : "-" }}
                            </template-->
              <DxColumn
                data-field="InvoiceStatusDescription"
                caption="Estado"
              ></DxColumn>
              <DxColumn data-field="Total" caption="Total"></DxColumn>
              <DxColumn data-field="Ambiente" caption="Ambiente"></DxColumn>
              </DxDataGrid>
            </GeneralFilter>

          <div class="black--text">
            <v-card
              rounded="lg"
              class="mx-6 mb-10 py-2"
              color="white"
              elevation="5"
            >
              <v-row no-gutters justify="center">
                <v-col
                  v-for="summary in cashierCutGeneralSummaryRows"
                  :key="summary.key"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="py-4 px-2"
                >
                  <div class="text-center font-weight-bold">
                    {{ summary.label }}
                  </div>
                  <div class="text-center text-h5 font-weight-light">
                    $ {{ formatAmount(summary.value) }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-tab-item>
        <v-tab-item v-if="canViewCashierReports" value="2">
          <v-row>
            <v-col cols="12" md="12" style="margin-top: 30px;" class="d-flex justify-end">
              <template>
                <v-btn
                  class="btn-save"
                  @click="
                    print2 = {
                      show: true,
                      data: { body: cashierCutDetails, dates: dates2 },
                    }
                  "
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
              <!-- Nuevo reporte corte caja   -->
              <template>
                <v-btn
                  style="margin-left: 5px;"
                  class="btn-color-white"
                  color="#00A178"
                  @click="printCashierCutDetailsPDF"
                > Detallado
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
            </v-col>
          </v-row>
          <v-row class="my-8 mx-1 mb-2 cashier-cut-filter-row">
            <v-col cols="12" md="3">
              <v-select
                v-model="dates2.typeDate"
                :items="dateTypeOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                label="Tipo de fecha"
                @change="handleCashierCutDateTypeChange('details', $event)"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="selectedCashierCutDetailsUserId"
                :items="cashierCutUserOptions"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                label="Usuario"
                @change="handleCashierCutDetailsUserChange"
              />
            </v-col>
            <v-col cols="12" md="6">
              <date-filter
                @datesSelected="setDates2"
                :search="{ typeData: dates2.typeData, typeDate: dates2.typeDate, filter: dates2.filter }"
                class="cashier-cut-date-filter"
                @filtered-data="dateFilterHandler2"
                @filtered-loading="loading = $event"
                :dataToFilter="getCashierCutDetails"
                :filterEndpoint="$API.invoices.getCashierCutDetails"
                :isFilteredByOutsource="false"
              />
            </v-col>
          </v-row>
          <GeneralFilter
            class="background border-box"
            :filterEndpoint="$API.invoices.getCashierCutDetails"
            :search="dates2"
            @emptyFilter="getCashierCutDetails"
            @filtered="filterHandler2"
            @loading="loading = $event"
          >
            <v-row class="mt-4 mr-2 ml-2">
              <v-col cols="12">
                <v-checkbox
                  @change="onShowAllRows"
                  label="Ocultar fila de fechas en el reporte"
                />
              </v-col>
            </v-row>
            <DxDataGrid
              :dataSource="getValidCutDataDetails(cashierCutDetails)"
              :showBorders="true"
              ref="dataGrid"
              :scrolling="{ useNative: true }"
              @exporting="onExporting2"
              :paging="{ enabled: false }"
              style="max-height: 600px"
            >
              <DxExport :enabled="true" />
              <DxColumn dataField="InvoiceDate" caption="Fecha" />
              <DxColumn dataField="Total" caption="Total" />
              <DxColumn dataField="ID_Invoice" caption="ID Factura" />
              <DxColumn dataField="InvoiceName" caption="Cliente" />
              <DxColumn
                dataField="CodigoGeneracion"
                caption="Código Generación"
              />
              <DxColumn dataField="NumeroControl" caption="Número de control" />
              <DxColumn dataField="SelloRecepcion" caption="Sello Recepción" />
              <DxColumn dataField="DescPaymentType" caption="Tipo de pago" />
              <DxColumn dataField="InvoiceStatusDescription" caption="Estado" />
              <DxColumn
                :group-index="0"
                v-if="showRowDate"
                data-field="FormattedDate"
                caption="Fecha"
                :calculate-display-value="getCustomCell"
                :sortOrder="'desc'"
              />

              <DxPager
                :visible="true"
                :show-page-size-selector="false"
                :show-info="false"
                :show-navigation-buttons="true"
              />
              <!--DxPaging :page-size="25" /-->
              <DxPager :showPageSizeSelector="true" />
            </DxDataGrid>
          </GeneralFilter>
          <div class="black--text">
            <v-card
              rounded="lg"
              class="mx-6 mb-10 py-2"
              color="white"
              elevation="5"
            >
              <v-row no-gutters justify="center">
                <v-col
                  v-for="summary in cashierCutDetailsSummaryRows"
                  :key="summary.key"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="py-4 px-2"
                >
                  <div class="text-center font-weight-bold">
                    {{ summary.label }}
                  </div>
                  <div class="text-center text-h5 font-weight-light">
                    $ {{ formatAmount(summary.value) }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-tab-item>
        <v-tab-item value="3">
          <v-card flat class="pa-4 mt-2">
            <v-card outlined class="pa-4 cash-close-card cash-close-card--header">
              <div class="cash-close-header">
                <div class="cash-close-header__summary">
                  <div class="font-weight-bold mb-3">Estado de caja</div>
                  <div class="cash-close-header__meta">
                    <div class="cash-close-header__item">
                      <span class="cash-close-header__label">Punto de venta</span>
                      <span class="cash-close-header__value">
                        {{ activeCashOpeningPointSale || 'Sin definir' }}
                      </span>
                    </div>
                    <div class="cash-close-header__item">
                      <span class="cash-close-header__label">Estado</span>
                      <span class="cash-close-header__value">
                        {{ hasActiveCashOpening ? 'Caja abierta' : 'Sin apertura activa' }}
                      </span>
                    </div>
                    <div v-if="hasActiveCashOpening" class="cash-close-header__item">
                      <span class="cash-close-header__label">Apertura</span>
                      <span class="cash-close-header__value">
                        {{ formatDate(activeCashOpeningOpenedAt) }}
                      </span>
                    </div>
                    <div v-if="hasActiveCashOpening" class="cash-close-header__item">
                      <span class="cash-close-header__label">Usuario</span>
                      <span class="cash-close-header__value">
                        {{ activeCashOpeningOwnerName || 'Sin definir' }}
                      </span>
                    </div>
                    <div v-if="hasActiveCashOpening" class="cash-close-header__item">
                      <span class="cash-close-header__label">Fondo inicial</span>
                      <span class="cash-close-header__value">
                        {{ formatAmount(activeCashOpeningAmount) }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="cash-close-header__actions">
                  <div class="font-weight-bold mb-3">Acciones de cierre</div>
                  <div class="cash-close-header__buttons">
                    <v-btn
                      color="primary"
                      class="mr-3 mb-3"
                      :disabled="!hasActiveCashOpening"
                      @click="cashControlDialog = true"
                    >
                      Caja chica
                    </v-btn>
                    <v-btn
                      color="error"
                      class="mb-3"
                      :disabled="!hasActiveCashOpening"
                      @click="cashOpeningDialog = true"
                    >
                      Cerrar caja
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>

            <v-card outlined class="pa-5 pt-7 cash-close-card cash-close-card--full mt-4">
              <v-tabs v-model="cashCloseTab" background-color="transparent" class="cash-close-tabs">
                <v-tab href="#cash-close-history">Aperturas y cierres</v-tab>
                <v-tab href="#cash-close-controls">Registros de caja chica</v-tab>
              </v-tabs>

              <v-tabs-items v-model="cashCloseTab" touchless>
                <v-tab-item value="cash-close-history">
                  <div class="mt-4">
                    <div class="d-flex justify-end mb-3">
                      <v-btn
                        small
                        color="primary"
                        :loading="cashOpeningBulkPrintLoading"
                        :disabled="cashOpeningHistoryLoading || !cashOpeningList.length"
                        @click="printFilteredCashOpeningSummaries"
                      >
                        <v-icon left small>mdi-printer</v-icon>
                        Imprimir filtrados
                      </v-btn>
                    </div>
                    <VersatileFilter
                      advanced-filter
                      :disable-dates="true"
                      :hide-search-field="true"
                      :search="cashOpeningHistorySearch"
                      :columnfilter-endpoint="filterCashOpeningHistoryAdvanced"
                      :columns-search="cashOpeningHistoryAdvancedFilters"
                      @emptyFilter="fetchCashOpeningHistory"
                      @filtered="handleCashOpeningHistoryFiltered"
                    >
                      <template #complementFilters>
                        <div class="mb-3 text-body-2">
                          {{ isAdminCashView ? 'Mostrando registros de todos los usuarios.' : 'Mostrando solo sus registros.' }}
                        </div>
                      </template>

                      <DxDataGrid
                        class="isScrolledByGeneralFilter"
                        :data-source="cashOpeningList"
                        key-expr="ID_CashOpening"
                        :show-row-lines="true"
                        :show-borders="true"
                        :row-alternation-enabled="true"
                        :hover-state-enabled="true"
                        :loading="cashOpeningHistoryLoading"
                      >
                        <DxPaging :page-size="10" />
                        <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50]" />
                        <DxScrolling row-rendering-mode="standard" />
                        <DxColumn data-field="DisplayOpeningId" caption="No. apertura" :width="110" />
                        <DxColumn data-field="FullName" caption="Usuario" />
                        <DxColumn data-field="PointSale" caption="PV" :width="90" />
                        <DxColumn data-field="OpenedAt" caption="Apertura" cell-template="opened-at-cell" />
                        <DxColumn data-field="ClosedAt" caption="Cierre" cell-template="closed-at-cell" />
                        <DxColumn :width="110" cell-template="detail-action-cell" caption="" />

                        <template #opened-at-cell="{ data }">
                          <span>{{ formatDate(data.data.OpenedAt) }}</span>
                        </template>

                        <template #closed-at-cell="{ data }">
                          <span>{{ getCashOpeningStatusLabel(data.data) }}</span>
                        </template>

                        <template #detail-action-cell="{ data }">
                          <a
                            v-if="data.data.ClosedAt"
                            href="#"
                            class="mx-1"
                            @click.prevent="openCashOpeningDetailModal(data.data)"
                          >
                            <v-icon color="primary">mdi-eye</v-icon>
                          </a>
                          <span v-else class="grey--text text--lighten-1">-</span>
                        </template>
                      </DxDataGrid>
                    </VersatileFilter>
                  </div>
                </v-tab-item>

                <v-tab-item value="cash-close-controls">
                  <div class="cash-close-tab-panel">
                    <VersatileFilter
                      v-if="isAdminCashView"
                      advanced-filter
                      :disable-dates="true"
                      :hide-search-field="true"
                      :search="cashControlSearch"
                      :columnfilter-endpoint="filterCashControlsAdvanced"
                      :columns-search="cashControlAdvancedFilters"
                      @emptyFilter="fetchCashControlRecords"
                      @filtered="handleCashControlFiltered"
                    >
                      <template #complementFilters>
                        <div class="mb-3 text-body-2">
                          Mostrando movimientos de caja chica de todos los usuarios.
                        </div>
                      </template>
                    </VersatileFilter>

                    <div v-else class="mb-4 text-body-2">
                      {{ hasActiveCashOpening ? 'Mostrando los registros de caja chica de su apertura actual.' : 'No hay una apertura activa para mostrar registros de caja chica.' }}
                    </div>

                    <div>
                      <DxDataGrid
                        class="isScrolledByGeneralFilter"
                        :data-source="cashControlRecords"
                        key-expr="ID_CashControl"
                        :show-row-lines="true"
                        :show-borders="true"
                        :row-alternation-enabled="true"
                        :hover-state-enabled="true"
                        :loading="cashControlRecordsLoading"
                      >
                        <DxPaging :page-size="10" />
                        <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50]" />
                        <DxScrolling row-rendering-mode="standard" />
                        <DxColumn data-field="CreatedAt" caption="Fecha" cell-template="cash-control-date-cell" :width="190" />
                        <DxColumn
                          v-if="isAdminCashView"
                          caption="Usuario"
                          cell-template="cash-control-user-cell"
                        />
                        <DxColumn caption="Tipo" cell-template="cash-control-type-cell" :width="120" />
                        <DxColumn data-field="Detail" caption="Detalle" />
                        <DxColumn data-field="Amount" caption="Monto" cell-template="cash-control-amount-cell" :width="120" />
                        <DxColumn caption="" cell-template="cash-control-print-cell" :width="90" />

                        <template #cash-control-user-cell="{ data }">
                          <span>{{ getCashControlUserLabel(data.data) }}</span>
                        </template>

                        <template #cash-control-type-cell="{ data }">
                          <span>{{ getCashControlMovementTypeLabel(data.data.MovementType) }}</span>
                        </template>

                        <template #cash-control-amount-cell="{ data }">
                          <span>{{ formatAmount(data.data.Amount) }}</span>
                        </template>

                        <template #cash-control-date-cell="{ data }">
                          <span>{{ data.data.CreatedAt ? formatDate(data.data.CreatedAt) : '-' }}</span>
                        </template>

                        <template #cash-control-print-cell="{ data }">
                          <v-btn
                            icon
                            small
                            color="primary"
                            title="Imprimir comprobante"
                            @click="printCashControlRecord(data.data)"
                          >
                            <v-icon small>mdi-printer</v-icon>
                          </v-btn>
                        </template>
                      </DxDataGrid>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card>

            <v-dialog
              v-model="cashOpeningDetailDialog"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              max-width="1100"
              scrollable
            >
              <v-card>
                <v-card-title class="d-flex justify-space-between align-center flex-wrap">
                  <span class="font-weight-bold">Detalle de caja</span>
                  <v-btn icon @click="cashOpeningDetailDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text class="pt-2">
                  <div class="mb-4 cash-opening-detail-toolbar">
                    <v-checkbox
                      v-model="hideZeroAmountPaymentMethods"
                      dense
                      hide-details
                      class="mr-3 mt-0 pt-0"
                      label="Omitir formas de pago en cero"
                    />
                    <div class="cash-opening-detail-toolbar__actions">
                      <v-btn
                        v-if="selectedCashOpeningSummary"
                        small
                        color="warning"
                        class="mr-3 mb-2"
                        :loading="cashOpeningReopenLoading"
                        :disabled="!canReopenSelectedCashOpening"
                        @click="reopenSelectedCashOpening"
                      >
                        <v-icon left small>mdi-lock-open-variant-outline</v-icon>
                        Reaperturar
                      </v-btn>
                      <v-btn
                        small
                        color="primary"
                        class="mb-2"
                        :disabled="!selectedCashOpeningSummary"
                        @click="printSelectedCashOpeningSummary"
                      >
                        <v-icon left small>mdi-printer</v-icon>
                        PDF
                      </v-btn>
                    </div>
                  </div>

                  <div v-if="selectedCashOpeningSummary">
                    <v-row class="mb-2">
                      <v-col cols="12" md="8">
                        <div><strong>Usuario:</strong> {{ selectedCashOpeningSummary.opening.fullName }}</div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div><strong>No. apertura:</strong> {{ getCashOpeningDisplayId(selectedCashOpeningSummary.opening) }}</div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div><strong>Apertura:</strong> {{ formatDate(selectedCashOpeningSummary.opening.openedAt) }}</div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div><strong>Cierre:</strong> {{ selectedCashOpeningSummary.opening.closedAt ? formatDate(selectedCashOpeningSummary.opening.closedAt) : 'Pendiente' }}</div>
                      </v-col>
                      <v-col v-if="selectedCashOpeningSummary.opening.reopenedAt" cols="12" md="6">
                        <div><strong>Reapertura:</strong> {{ formatDate(selectedCashOpeningSummary.opening.reopenedAt) }}</div>
                      </v-col>
                      <v-col v-if="selectedCashOpeningSummary.opening.reopenedByUserId" cols="12" md="6">
                        <div><strong>Reaperturado por:</strong> {{ selectedCashOpeningSummary.opening.reopenedByUserId }}</div>
                      </v-col>
                      <v-col v-if="selectedCashOpeningSummary.opening.reclosedAt" cols="12" md="6">
                        <div><strong>Ultimo recierre:</strong> {{ formatDate(selectedCashOpeningSummary.opening.reclosedAt) }}</div>
                      </v-col>
                      <v-col v-if="selectedCashOpeningSummary.opening.reclosedByUserId" cols="12" md="6">
                        <div><strong>Recerrado por:</strong> {{ selectedCashOpeningSummary.opening.reclosedByUserId }}</div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div><strong>Fondo inicial:</strong> {{ formatAmount(selectedCashOpeningSummary.opening.openingAmount) }}</div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div><strong>Monto cierre:</strong> {{ selectedCashOpeningSummary.opening.closingAmount !== null ? formatAmount(selectedCashOpeningSummary.opening.closingAmount) : 'Pendiente' }}</div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div><strong>Punto de venta:</strong> {{ selectedCashOpeningSummary.opening.pointSale || 'Sin definir' }}</div>
                      </v-col>
                    </v-row>

                    <div class="font-weight-bold mt-4 mb-2">Totales de cierre</div>
                    <v-simple-table dense class="mb-4">
                      <thead>
                        <tr>
                          <th>Detalle</th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in selectedCashOpeningSummary.closingMovements" :key="'movement-' + index">
                          <td>{{ item.detail }}</td>
                          <td>{{ formatAmount(item.amount) }}</td>
                        </tr>
                        <tr v-if="selectedCashOpeningSummary.closingMovements.length" class="font-weight-bold">
                          <td>Total</td>
                          <td>{{ formatAmount(selectedCashOpeningClosingMovementsTotal) }}</td>
                        </tr>
                        <tr v-if="!selectedCashOpeningSummary.closingMovements.length">
                          <td colspan="2" class="text-center">Sin datos</td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <div class="font-weight-bold mt-4 mb-2">Arqueo de caja</div>
                    <v-simple-table dense class="mb-4">
                      <thead>
                        <tr>
                          <th>Forma de pago</th>
                          <th>Monto calculado</th>
                          <th>Monto usuario</th>
                          <th>Diferencia</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in filteredSelectedCashOpeningArqueoRows" :key="'arqueo-' + index">
                          <td>{{ item.paymentMethod }}</td>
                          <td>{{ formatAmount(item.appAmount) }}</td>
                          <td>{{ item.userAmount === null || item.userAmount === undefined ? '-' : formatAmount(item.userAmount) }}</td>
                          <td>{{ item.differenceAmount === null || item.differenceAmount === undefined ? '-' : formatAmount(item.differenceAmount) }}</td>
                        </tr>
                        <tr v-if="filteredSelectedCashOpeningArqueoRows.length" class="font-weight-bold">
                          <td>Total</td>
                          <td>{{ formatAmount(selectedCashOpeningArqueoTotals.appAmount) }}</td>
                          <td>{{ formatAmount(selectedCashOpeningArqueoTotals.userAmount) }}</td>
                          <td>{{ formatAmount(selectedCashOpeningArqueoTotals.differenceAmount) }}</td>
                        </tr>
                        <tr v-if="!filteredSelectedCashOpeningArqueoRows.length">
                          <td colspan="4" class="text-center">Sin datos</td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <div class="font-weight-bold mt-4 mb-2">Caja chica y registros</div>
                    <v-simple-table dense class="mb-4">
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Tipo</th>
                          <th>Detalle</th>
                          <th>Monto</th>
                          <th>Responsable</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in selectedCashOpeningSummary.controls || []" :key="'control-' + index">
                          <td>{{ item.createdAt ? formatDate(item.createdAt) : '-' }}</td>
                          <td>{{ getCashControlMovementTypeLabel(item.movementType) }}</td>
                          <td>{{ item.detail || '-' }}</td>
                          <td>{{ formatAmount(item.amount) }}</td>
                          <td>{{ item.externalResponsible || item.internalResponsibleUserId || '-' }}</td>
                        </tr>
                        <tr v-if="!(selectedCashOpeningSummary.controls || []).length">
                          <td colspan="5" class="text-center">Sin registros</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <div v-else class="text-body-2 grey--text text--darken-1">
                    Seleccione una apertura para ver su detalle.
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div>
      <alerts
        v-for="(item, index) in printList"
        :key="index"
        :is="item.component"
        :dataProps="item.data"
      />
    </div>

    <PrintCashierCutDetails :dataProps="print2"></PrintCashierCutDetails>
    <print-cut-cashier-v-2 v-model="print3"></print-cut-cashier-v-2>
    <cash-opening-modal
      :value="cashOpeningDialog"
      :status="resolvedCashOpeningStatus"
      :summary-type-data="dates.typeData"
      :hide-close-button="false"
      :target-opening-id="cashOpeningDialogTargetOpeningId"
      :opening-override="cashOpeningStatusOverride"
      @input="cashOpeningDialog = $event"
      @status-updated="handleCashOpeningStatusUpdated"
    ></cash-opening-modal>
    <cash-control-modal
      :value="cashControlDialog"
      :status="resolvedCashOpeningStatus"
      :target-opening-id="cashOpeningDialogTargetOpeningId"
      :opening-override="cashOpeningStatusOverride"
      @input="cashControlDialog = $event"
      @status-updated="handleCashOpeningStatusUpdated"
    ></cash-control-modal>
    <alerts 
      v-if="invoiceDataErrorAlert.show" 
      v-on:close_alert="closeAlert(invoiceDataErrorAlert)" 
      v-on:accept_alert="acceptAlert(invoiceDataErrorAlert)" 
      :properties="invoiceDataErrorAlert">
    </alerts>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxPager,
  DxPaging,
  DxScrolling,
} from "devextreme-vue/data-grid";
import GeneralFilter from "@/components/GeneralFilter.vue";
import VersatileFilter from "@/components/VersatileFilter.vue";
import { printToExcel } from "@/helpers/printToexcel";
import Block from "@/components/Block";
import DateFilter from "@/components/DateFilter";
import PrintCutBox from "@/components/ReportsAndPrintings/AccountigReports/PrintCutBox";
import PrintCashierCutDetails from "../../components/ReportsAndPrintings/PrintCashierCutDetails.vue";
import PrintCutCashierV2 from "../../components/ReportsAndPrintings/PrintCutCashierV2.vue";
import { numberWithCommas } from "@/helpers/money";
import Alerts from "@/components/Alerts.vue";
import printCashierCutPDF from "@/components/ReportsAndPrintings/printCashierCutPDF";
import CashOpeningModal from "./CashOpeningModal.vue";
import CashControlModal from "./CashControlModal.vue";

export default {
  props: {
    reportModule: {
      type: Boolean,
      default: false,
    },
    isCarsem: {
      type: Boolean,
      default: false,
    },
    externalCashOpeningStatus: {
      type: Object,
      default: null,
    },
  },
  name: "CashierCut",
  components: {
    DxColumn,
    DxDataGrid,
    GeneralFilter,
    VersatileFilter,
    Block,
    DxExport,
    DateFilter,
    PrintCutBox,
    DxPager,
    DxPaging,
    DxScrolling,
    PrintCashierCutDetails,
    PrintCutCashierV2,
    Alerts,
    CashOpeningModal,
    CashControlModal
  },
  data() {
    return {
      loading: false,
      showRowDate: true,
      firstLoadTabs: {
        '1': false,
        '2': false,
      },
      cashierCut: [],
      cashierCutDetails: [],
      Currency: JSON.parse(localStorage.getItem("branch")).Currency,
      printList: [],
      dates: {
        start: null,
        end: null,
        typeData: "01",
        typeDate: 1,
        filter: "",
      },
      dates2: {
        start: null,
        end: null,
        typeData: "01",
        typeDate: 1,
        filter: "",
      },
      dateTypeOptions: [
        { text: "Fecha de comprobante", value: 1 },
        { text: "Fecha de creación", value: 2 },
      ],
      print: {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      },
      print2: {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      },
      print3: {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      },
      invoiceDataErrorAlert: {
        type: "success",
        show: false,
        header: "",
        body: "",
        seen: false
      },
      tab: null,
      totalContado: 0,
      totalInvalidado: 0,
      totalCredito: 0,
      totalAbonos: 0,
      totalAnticipos: 0,
      totalNeto: 0,
      totalContadoGeneral: 0,
      totalInvalidadoGeneral: 0,
      totalCreditoGeneral: 0,
      totalAbonoGeneral: 0,
      totalAnticiposGeneral: 0,
      totalNetoGeneral: 0,
      totalBillsAndCoins: 0,
      totalCards: 0,
      totalCheck: 0,
      totalTransfer: 0,
      totalOthers: 0,
      totalBillsAndCoinsGeneral: 0,
      totalCardsGeneral: 0,
      totalCheckGeneral: 0,
      totalTransferGeneral: 0,
      totalOthersGeneral: 0,
      cashierCutUsers: [],
      selectedCashierCutUserId: "",
      selectedCashierCutDetailsUserId: "",
      syncingCashierCutUserFilter: false,
      syncingCashierCutDetailsUserFilter: false,
      cashOpeningDialog: false,
      cashControlDialog: false,
      cashOpeningDialogTargetOpeningId: null,
      cashOpeningStatusOverride: null,
      cashOpeningHistoryLoading: false,
      cashCloseTab: "cash-close-history",
      cashOpeningStatus: {
        pointSale: localStorage.getItem("codPointSale") || null,
        activeOpening: null,
      },
      cashOpeningHistorySearch: {
        filter: "",
      },
      cashOpeningHistoryAdvancedFilters: [
        {
          name: "cashOpeningStartDate",
          title: "Fecha inicio",
          type: "date",
          value: null,
        },
        {
          name: "cashOpeningEndDate",
          title: "Fecha fin",
          type: "date",
          value: null,
        },
      ],
      adminCashOpeningUsers: [],
      cashOpeningList: [],
      cashOpeningBulkPrintLoading: false,
      cashOpeningReopenLoading: false,
      cashControlRecordsLoading: false,
      cashControlRecords: [],
      cashControlSearch: {
        filter: "",
      },
      cashControlAdvancedFilters: [
        {
          name: "cashControlStartDate",
          title: "Fecha inicio",
          type: "date",
          value: null,
        },
        {
          name: "cashControlEndDate",
          title: "Fecha fin",
          type: "date",
          value: null,
        },
        {
          name: "cashControlDetail",
          title: "Detalle",
          type: "text",
          value: "",
        },
      ],
      cashControlAppliedFilters: {
        userId: "",
        startDate: "",
        endDate: "",
        detail: "",
      },
      cashOpeningDetailDialog: false,
      selectedCashOpeningId: null,
      selectedCashOpeningSummary: null,
      hideZeroAmountPaymentMethods: false,
    };
  },
  mounted() {
    const date = new Date();
    this.dates.start =
      date.getFullYear() +
      "-" +
      this.padTo2Digits(date.getMonth() + 1) +
      "-" +
      this.padTo2Digits(date.getDate());
    this.dates.end =
      date.getFullYear() +
      "-" +
      this.padTo2Digits(date.getMonth() + 1) +
      "-" +
      this.padTo2Digits(date.getDate());
    this.dates2.start =
      date.getFullYear() +
      "-" +
      this.padTo2Digits(date.getMonth() + 1) +
      "-" +
      this.padTo2Digits(date.getDate());
    this.dates2.end =
      date.getFullYear() +
      "-" +
      this.padTo2Digits(date.getMonth() + 1) +
      "-" +
      this.padTo2Digits(date.getDate());

    this.fetchAdminCashOpeningUsers();
    this.loadData(this.tab);
  },
  watch: {
    "dates.filter"(value) {
      if (this.syncingCashierCutUserFilter) {
        return;
      }

      const normalizedValue = String(value || "").trim();
      const hasMatch = this.cashierCutUserOptions.some((item) => String(item.value || "") === normalizedValue);
      this.selectedCashierCutUserId = hasMatch ? normalizedValue : "";
    },
    "dates2.filter"(value) {
      if (this.syncingCashierCutDetailsUserFilter) {
        return;
      }

      const normalizedValue = String(value || "").trim();
      const hasMatch = this.cashierCutUserOptions.some((item) => String(item.value || "") === normalizedValue);
      this.selectedCashierCutDetailsUserId = hasMatch ? normalizedValue : "";
    },
    tab(val) {
      this.loadData(val);
    },
    canViewCashierReports: {
      immediate: true,
      handler(value) {
        if (!value && (this.tab === "1" || this.tab === "2")) {
          this.tab = "3";
        }
      },
    },
    externalCashOpeningStatus: {
      deep: true,
      immediate: true,
      handler(value) {
        this.syncCashOpeningStatus(value);
      },
    },
  },
  computed: {
    resolvedCashOpeningStatus() {
      const activeOpening = this.cashOpeningStatusOverride || this.cashOpeningStatus?.activeOpening || null;
      const pointSale = activeOpening?.PointSale
        || activeOpening?.pointSale
        || this.cashOpeningStatus?.pointSale
        || localStorage.getItem("codPointSale")
        || null;

      return {
        ...this.cashOpeningStatus,
        pointSale,
        activeOpening,
      };
    },
    activeCashOpeningData() {
      return this.resolvedCashOpeningStatus?.activeOpening || null;
    },
    hasActiveCashOpening() {
      return Boolean(this.activeCashOpeningData);
    },
    activeCashOpeningPointSale() {
      return this.activeCashOpeningData?.PointSale
        || this.activeCashOpeningData?.pointSale
        || this.resolvedCashOpeningStatus?.pointSale
        || null;
    },
    activeCashOpeningOpenedAt() {
      return this.activeCashOpeningData?.OpenedAt || this.activeCashOpeningData?.openedAt || null;
    },
    activeCashOpeningAmount() {
      return this.activeCashOpeningData?.OpeningAmount ?? this.activeCashOpeningData?.openingAmount ?? 0;
    },
    activeCashOpeningOwnerName() {
      return this.activeCashOpeningData?.FullName
        || this.activeCashOpeningData?.fullName
        || this.activeCashOpeningData?.UserName
        || this.activeCashOpeningData?.userName
        || this.getInternalUserName(this.getOpeningUserId(this.activeCashOpeningData))
        || "";
    },
    hasStrictCashClosing() {
      const statusValue = this.resolvedCashOpeningStatus?.strictCashClosing ?? this.resolvedCashOpeningStatus?.StrictCashClosing;
      if (statusValue !== undefined && statusValue !== null) {
        return Boolean(statusValue);
      }

      try {
        const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
        return Boolean(storedUser.strictCashClosing || storedUser.StrictCashClosing);
      } catch (error) {
        return false;
      }
    },
    canViewCashierReports() {
      return this.isAdminCashView || !(this.hasActiveCashOpening && this.hasStrictCashClosing);
    },
    canReopenSelectedCashOpening() {
      const selectedOpening = this.selectedCashOpeningSummary?.opening || null;
      const selectedOpeningId = this.getOpeningId(selectedOpening);
      const selectedOpeningUserId = this.getOpeningUserId(selectedOpening);

      if (!this.isAdminCashView || !selectedOpeningId || !selectedOpeningUserId) {
        return false;
      }

      if (!this.isCashOpeningClosed(selectedOpening)) {
        return false;
      }

      const targetUserHasActiveOpening = this.cashOpeningList.some((item) => (
        String(this.getOpeningId(item) || "") !== String(selectedOpeningId)
        && String(this.getOpeningUserId(item) || "") === String(selectedOpeningUserId)
        && this.isCashOpeningActive(item)
      ));

      const currentManagedOpeningId = this.getOpeningId(this.activeCashOpeningData);
      const hasAnotherManagedActiveOpening = Boolean(
        currentManagedOpeningId
        && String(currentManagedOpeningId) !== String(selectedOpeningId)
      );

      return !targetUserHasActiveOpening && !hasAnotherManagedActiveOpening;
    },
    currentInternalUserId() {
      const currentUser = this.getCurrentUser();
      return String(currentUser?.id || currentUser?.ID_User || "").trim();
    },
    isAdminCashView() {
      return Boolean(this.$store.getters["rolesUser/isAdminOrManager"]);
    },
    cashControlUserOptions() {
      return [
        { name: "Todos", value: "" },
        ...this.adminCashOpeningUsers.map((item) => ({
          name: item.FullName || item.UserName || item.ID_User,
          value: item.ID_User,
        })),
      ];
    },
    cashierCutUserOptions() {
      return [
        { text: "Todos", value: "" },
        ...this.cashierCutUsers.map((item) => ({
          text: item.FullName || item.UserName || item.ID_User,
          value: String(item.ID_User || ""),
        })),
      ];
    },
    cashierCutGeneralSummaryRows() {
      return this.buildCashierCutSummaryRows({
        contado: this.totalContadoGeneral,
        billsAndCoins: this.totalBillsAndCoinsGeneral,
        cards: this.totalCardsGeneral,
        check: this.totalCheckGeneral,
        transfer: this.totalTransferGeneral,
        others: this.totalOthersGeneral,
        credito: this.totalCreditoGeneral,
        abonos: this.totalAbonoGeneral,
        anticipos: this.totalAnticiposGeneral,
        invalidado: this.totalInvalidadoGeneral,
        neto: this.totalNetoGeneral,
      });
    },
    cashierCutDetailsSummaryRows() {
      return this.buildCashierCutSummaryRows({
        contado: this.totalContado,
        billsAndCoins: this.totalBillsAndCoins,
        cards: this.totalCards,
        check: this.totalCheck,
        transfer: this.totalTransfer,
        others: this.totalOthers,
        credito: this.totalCredito,
        abonos: this.totalAbonos,
        anticipos: this.totalAnticipos,
        invalidado: this.totalInvalidado,
        neto: this.totalNeto,
      });
    },
    selectedCashOpeningClosingMovementsTotal() {
      return (this.selectedCashOpeningSummary?.closingMovements || []).reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );
    },
    filteredSelectedCashOpeningArqueoRows() {
      return this.getFilteredArqueoRows(this.selectedCashOpeningSummary?.arqueoRows || []);
    },
    selectedCashOpeningArqueoTotals() {
      return this.filteredSelectedCashOpeningArqueoRows.reduce((totals, item) => ({
        appAmount: totals.appAmount + Number(item.appAmount || 0),
        userAmount: totals.userAmount + Number(item.userAmount || 0),
        differenceAmount: totals.differenceAmount + Number(item.differenceAmount || 0),
      }), {
        appAmount: 0,
        userAmount: 0,
        differenceAmount: 0,
      });
    },
    formatDateToDDMMYYYYEnd() {
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.dates2.end)) {
        return this.dates2.end;
      }
      const d = new Date(this.dates2.end);
      if (isNaN(d.getTime())) {
        return this.dates2.end;
      }
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Los meses van de 0 (enero) a 11 (diciembre)
      const year = d.getFullYear();

      return `${day}/${month}/${year}`;
    },
    formatDateToDDMMYYYYStart() {
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.dates2.start)) {
        return this.dates2.start;
      }
      const d = new Date(this.dates2.start);
      if (isNaN(d.getTime())) {
        return this.dates2.start;
      }
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Los meses van de 0 (enero) a 11 (diciembre)
      const year = d.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    getCurrentUser() {
      try {
        return JSON.parse(localStorage.getItem("user") || "{}") || {};
      } catch (error) {
        return {};
      }
    },
    getDateOnlyValue(value) {
      if (!value) {
        return "";
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    normalizeFilterDate(value) {
      const rawValue = String(value || "").trim();
      if (!rawValue) {
        return undefined;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) {
        return rawValue;
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(rawValue)) {
        const [day, month, year] = rawValue.split("/");
        return `${year}-${month}-${day}`;
      }

      const parsedDate = new Date(rawValue);
      if (Number.isNaN(parsedDate.getTime())) {
        return rawValue;
      }

      return this.getDateOnlyValue(parsedDate);
    },
    parseMoney(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }

      return Number(String(value).replace(/[$,]/g, "")) || 0;
    },
    normalizeInvoiceStatus(value) {
      return String(value || "")
        .trim()
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    buildCashierCutSummaryRows(totals = {}) {
      return [
        {
          key: "contado",
          label: "Total ventas canceladas / contado",
          value: totals.contado || 0,
        },
        {
          key: "billsAndCoins",
          label: "Total billetes y monedas",
          value: totals.billsAndCoins || 0,
        },
        {
          key: "cards",
          label: "Total tarjeta",
          value: totals.cards || 0,
        },
        {
          key: "check",
          label: "Total cheque",
          value: totals.check || 0,
        },
        {
          key: "transfer",
          label: "Total transferencia",
          value: totals.transfer || 0,
        },
        {
          key: "others",
          label: "Total otros",
          value: totals.others || 0,
        },
        {
          key: "credito",
          label: "Total crédito",
          value: totals.credito || 0,
        },
        {
          key: "abonos",
          label: "Total abonos",
          value: totals.abonos || 0,
        },
        {
          key: "anticipos",
          label: "Total anticipos",
          value: totals.anticipos || 0,
        },
        {
          key: "invalidado",
          label: "Total invalidaciones / notas de crédito / notas de débito",
          value: totals.invalidado || 0,
        },
        {
          key: "neto",
          label: "Total neto de ventas",
          value: totals.neto || 0,
        },
      ];
    },
    calculateCashierCutTotals(rows = []) {
      const totals = {
        totalContado: 0,
        totalInvalidado: 0,
        totalCredito: 0,
        totalAbonos: 0,
        totalAnticipos: 0,
        totalBillsAndCoins: 0,
        totalCards: 0,
        totalCheck: 0,
        totalTransfer: 0,
        totalOthers: 0,
        totalNeto: 0,
      };
      const excludedPaymentStatuses = new Set([
        "INVALIDADO",
        "NOTA DE CREDITO",
        "NOTA DE DEBITO",
        "CREDITO",
      ]);

      rows.forEach((item) => {
        const status = this.normalizeInvoiceStatus(item.InvoiceStatusDescription);
        const amount = this.parseMoney(item.Total);
        const saleAmount = this.parseMoney(item.TotalSale);
        const paymentCode = String(item.Codigo || "").trim();

        if (status === "CANCELADA") {
          totals.totalContado += amount;
        }

        if (status === "ABONO") {
          totals.totalAbonos += amount;
        }

        if (status === "CREDITO") {
          totals.totalCredito += amount;
        }

        if (status === "ANTICIPO") {
          totals.totalAnticipos += amount;
        }

        if (status === "INVALIDADO" || status === "NOTA DE CREDITO" || status === "NOTA DE DEBITO") {
          totals.totalInvalidado += Math.abs(amount);
        }

        if (!excludedPaymentStatuses.has(status)) {
          if (paymentCode === "01") {
            totals.totalBillsAndCoins += saleAmount;
          } else if (["02", "03"].includes(paymentCode)) {
            totals.totalCards += saleAmount;
          } else if (paymentCode === "04") {
            totals.totalCheck += saleAmount;
          } else if (paymentCode === "05") {
            totals.totalTransfer += saleAmount;
          } else if (
            status !== "CREDITO" &&
            status !== "INVALIDADO" &&
            status !== "NOTA DE CREDITO" &&
            status !== "NOTA DE DEBITO"
          ) {
            totals.totalOthers += saleAmount;
          }
        }
      });

      totals.totalNeto = totals.totalContado - Math.abs(totals.totalInvalidado);

      return totals;
    },
    buildCashierCutTotalsState(rows = [], general = false) {
      const totals = this.calculateCashierCutTotals(rows);

      if (general) {
        return {
          totalContadoGeneral: totals.totalContado,
          totalInvalidadoGeneral: totals.totalInvalidado,
          totalCreditoGeneral: totals.totalCredito,
          totalAbonoGeneral: totals.totalAbonos,
          totalAnticiposGeneral: totals.totalAnticipos,
          totalBillsAndCoinsGeneral: totals.totalBillsAndCoins,
          totalCardsGeneral: totals.totalCards,
          totalCheckGeneral: totals.totalCheck,
          totalTransferGeneral: totals.totalTransfer,
          totalOthersGeneral: totals.totalOthers,
          totalNetoGeneral: totals.totalNeto,
        };
      }

      return {
        totalContado: totals.totalContado,
        totalInvalidado: totals.totalInvalidado,
        totalCredito: totals.totalCredito,
        totalAbonos: totals.totalAbonos,
        totalAnticipos: totals.totalAnticipos,
        totalBillsAndCoins: totals.totalBillsAndCoins,
        totalCards: totals.totalCards,
        totalCheck: totals.totalCheck,
        totalTransfer: totals.totalTransfer,
        totalOthers: totals.totalOthers,
        totalNeto: totals.totalNeto,
      };
    },
    clearCashierCutUserFilter(filterKey) {
      if (filterKey === "general") {
        this.syncingCashierCutUserFilter = true;
        this.dates.filter = String(this.selectedCashierCutUserId || "").trim();
        this.$nextTick(() => {
          this.syncingCashierCutUserFilter = false;
        });
        return;
      }

      this.syncingCashierCutDetailsUserFilter = true;
      this.dates2.filter = String(this.selectedCashierCutDetailsUserId || "").trim();
        this.$nextTick(() => {
          this.syncingCashierCutDetailsUserFilter = false;
        });
    },
    async handleCashierCutDateTypeChange(source, value) {
      const nextValue = Number(value || (source === "general" ? this.dates.typeDate : this.dates2.typeDate)) || 1;

      if (source === "details") {
        this.dates2.typeDate = nextValue;
        this.dates.typeDate = nextValue;
      } else {
        this.dates.typeDate = nextValue;
        this.dates2.typeDate = nextValue;
      }

      if (this.tab === "1") {
        await this.getCashierCut();
        return;
      }

      if (this.tab === "2") {
        await this.getCashierCutDetails();
      }
    },
    async handleCashierCutTypeDataChange(value) {
      this.dates.typeData = value;
      this.dates2.typeData = value;

      if (this.tab === "1") {
        await this.getCashierCut();
        return;
      }

      if (this.tab === "2") {
        await this.getCashierCutDetails();
      }
    },
    async handleCashierCutUserChange(value) {
      this.selectedCashierCutUserId = String(value || "").trim();
      this.clearCashierCutUserFilter("general");

      if (this.tab === "1") {
        await this.getCashierCut();
      }
    },
    async handleCashierCutDetailsUserChange(value) {
      this.selectedCashierCutDetailsUserId = String(value || "").trim();
      this.clearCashierCutUserFilter("details");

      if (this.tab === "2") {
        await this.getCashierCutDetails();
      }
    },
    syncCashOpeningStatus(status = null) {
      if (!status || typeof status !== "object") {
        return;
      }

      this.cashOpeningStatus = {
        ...this.cashOpeningStatus,
        ...status,
        pointSale: status.pointSale || this.cashOpeningStatus.pointSale || localStorage.getItem("codPointSale") || null,
        activeOpening: status.activeOpening || null,
      };
    },
    ensureCashOpeningUserAdvancedFilter() {
      const filterName = "cashOpeningUserId";
      const currentIndex = this.cashOpeningHistoryAdvancedFilters.findIndex((item) => item.name === filterName);

      if (!this.isAdminCashView) {
        if (currentIndex >= 0) {
          this.cashOpeningHistoryAdvancedFilters.splice(currentIndex, 1);
        }
        return;
      }

      const options = this.adminCashOpeningUsers.map((item) => ({
        name: item.FullName || item.UserName || item.ID_User,
        value: item.ID_User,
      }));

      const currentValue = currentIndex >= 0
        ? this.cashOpeningHistoryAdvancedFilters[currentIndex].value
        : "";

      const userFilter = {
        name: filterName,
        title: "Usuario",
        type: "select",
        value: currentValue || "",
        options: [
          { name: "Todos", value: "" },
          ...options,
        ],
      };

      if (currentIndex >= 0) {
        this.cashOpeningHistoryAdvancedFilters.splice(currentIndex, 1, userFilter);
        return;
      }

      this.cashOpeningHistoryAdvancedFilters.push(userFilter);
    },
    ensureCashControlUserAdvancedFilter() {
      const filterName = "cashControlUserId";
      const currentIndex = this.cashControlAdvancedFilters.findIndex((item) => item.name === filterName);

      if (!this.isAdminCashView) {
        if (currentIndex >= 0) {
          this.cashControlAdvancedFilters.splice(currentIndex, 1);
        }
        return;
      }

      const userFilter = {
        name: filterName,
        title: "Usuario",
        type: "select",
        value: currentIndex >= 0 ? this.cashControlAdvancedFilters[currentIndex].value || "" : "",
        options: this.cashControlUserOptions,
      };

      if (currentIndex >= 0) {
        this.cashControlAdvancedFilters.splice(currentIndex, 1, userFilter);
        return;
      }

      this.cashControlAdvancedFilters.push(userFilter);
    },
    getSelectedCashOpeningHistoryUserId() {
      const userFilter = this.cashOpeningHistoryAdvancedFilters.find((item) => item.name === "cashOpeningUserId");
      return String(userFilter?.value || "").trim() || undefined;
    },
    async fetchAdminCashOpeningUsers() {
      try {
        const response = await this.$API.cashOpening.getInternalUsers();
        const users = Array.isArray(response?.data) ? response.data : [];
        this.cashierCutUsers = users;
        this.adminCashOpeningUsers = this.isAdminCashView ? users : [];
      } catch (error) {
        console.error("fetchAdminCashOpeningUsers", error);
        this.cashierCutUsers = [];
        this.adminCashOpeningUsers = [];
      } finally {
        this.ensureCashOpeningUserAdvancedFilter();
        this.ensureCashControlUserAdvancedFilter();
      }
    },
    getCurrentPointSale() {
      return localStorage.getItem("codPointSale") || this.resolvedCashOpeningStatus.pointSale || null;
    },
    async fetchCashOpeningStatus() {
      try {
        const response = await this.$API.cashOpening.getStatus();
        const status = response?.data || {};
        const currentPointSale = status.pointSale || this.getCurrentPointSale();

        this.cashOpeningStatus = {
          ...this.cashOpeningStatus,
          ...status,
          pointSale: currentPointSale,
          activeOpening: status.activeOpening || null,
        };
      } catch (error) {
        console.error("fetchCashOpeningStatus cash cut", error);
      }
    },
    async handleCashOpeningStatusUpdated(payload = null) {
      const currentPointSale = this.getCurrentPointSale();

      if (payload?.action === "opened" && payload.opening) {
        this.cashOpeningStatus = {
          pointSale: currentPointSale,
          activeOpening: payload.opening,
        };
        this.cashOpeningStatusOverride = null;
      }

      if (payload?.action === "closed") {
        this.cashOpeningStatus = {
          pointSale: currentPointSale,
          activeOpening: null,
        };
        this.cashOpeningStatusOverride = null;
        this.cashOpeningDialogTargetOpeningId = null;
      }

      await this.fetchCashOpeningStatus();
      await this.fetchCashOpeningHistory();
      await this.fetchCashControlRecords();

      if (!this.hasActiveCashOpening) {
        this.cashControlDialog = false;
      }

      this.cashOpeningDialog = false;
    },
    async fetchCashOpeningHistory() {
      this.cashOpeningHistoryLoading = true;
      try {
        const response = await this.$API.cashOpening.getOpenings({
          includeAllUsers: this.isAdminCashView ? 1 : 0,
          userId: this.getSelectedCashOpeningHistoryUserId(),
        });
        this.handleCashOpeningHistoryFiltered(response);
        if (!this.cashOpeningList.some((item) => String(item.ID_CashOpening) === String(this.selectedCashOpeningId))) {
          this.selectedCashOpeningId = null;
          this.selectedCashOpeningSummary = null;
        }
      } catch (error) {
        console.error("fetchCashOpeningHistory", error);
      } finally {
        this.cashOpeningHistoryLoading = false;
      }
    },
    getCashControlQueryParams() {
      const params = {};

      if (this.isAdminCashView) {
        return params;
      }

      const currentUser = this.getCurrentUser();
      params.openingId = this.getOpeningId(this.activeCashOpeningData) || undefined;
      params.userId = currentUser?.id || currentUser?.ID_User || undefined;
      return params;
    },
    async fetchCashControlRecords() {
      if (!this.isAdminCashView && !this.hasActiveCashOpening) {
        this.cashControlRecords = [];
        return;
      }

      this.cashControlRecordsLoading = true;
      try {
        const response = await this.$API.cashOpening.getControls(this.getCashControlQueryParams());
        this.cashControlRecords = Array.isArray(response?.data) ? response.data : [];
      } catch (error) {
        console.error("fetchCashControlRecords", error);
        this.cashControlRecords = [];
      } finally {
        this.cashControlRecordsLoading = false;
      }
    },
    async filterCashControlsAdvanced(payload = {}) {
      let parsedColumnFilters = [];

      try {
        parsedColumnFilters = JSON.parse(payload?.filter || "[]");
      } catch (error) {
        parsedColumnFilters = [];
      }

      const userId = String(
        parsedColumnFilters.find((item) => item.name === "cashControlUserId")?.value || ""
      ).trim();
      const startDate = this.normalizeFilterDate(
        parsedColumnFilters.find((item) => item.name === "cashControlStartDate")?.value || ""
      );
      const endDate = this.normalizeFilterDate(
        parsedColumnFilters.find((item) => item.name === "cashControlEndDate")?.value || ""
      );
      const detail = String(
        parsedColumnFilters.find((item) => item.name === "cashControlDetail")?.value || ""
      ).trim();

      this.cashControlAppliedFilters = {
        userId,
        startDate: startDate || "",
        endDate: endDate || "",
        detail: detail || "",
      };

      const response = await this.$API.cashOpening.getControls({
        ...this.getCashControlQueryParams(),
        userId: userId || undefined,
        startDate,
        endDate,
        detail: detail || undefined,
      });

      const records = Array.isArray(response?.data) ? response.data : [];

      return {
        ...response,
        data: records.filter((item) => {
          const itemUserId = String(item.ID_User || "");
          const itemDate = this.getDateOnlyValue(item.CreatedAt);
          const itemDetail = String(item.Detail || "").toLowerCase();

          if (userId && itemUserId !== userId) {
            return false;
          }

          if (startDate && (!itemDate || itemDate < startDate)) {
            return false;
          }

          if (endDate && (!itemDate || itemDate > endDate)) {
            return false;
          }

          if (detail && !itemDetail.includes(detail.toLowerCase())) {
            return false;
          }

          return true;
        }),
      };
    },
    handleCashControlFiltered(response) {
      this.cashControlRecords = Array.isArray(response?.data) ? response.data : [];
    },
    async filterCashOpeningHistoryAdvanced(payload = {}) {
      let parsedColumnFilters = [];
      try {
        parsedColumnFilters = JSON.parse(payload?.filter || "[]");
      } catch (error) {
        parsedColumnFilters = [];
      }

      const selectedUserFilter = Array.isArray(parsedColumnFilters)
        ? parsedColumnFilters.find((item) => item.name === "cashOpeningUserId")
        : null;
      const startDateFilter = Array.isArray(parsedColumnFilters)
        ? parsedColumnFilters.find((item) => item.name === "cashOpeningStartDate")
        : null;
      const endDateFilter = Array.isArray(parsedColumnFilters)
        ? parsedColumnFilters.find((item) => item.name === "cashOpeningEndDate")
        : null;
      return this.$API.cashOpening.getOpenings({
        includeAllUsers: this.isAdminCashView ? 1 : 0,
        startDate: String(startDateFilter?.value || "").trim() || undefined,
        endDate: String(endDateFilter?.value || "").trim() || undefined,
        userId: String(selectedUserFilter?.value || this.getSelectedCashOpeningHistoryUserId() || "").trim() || undefined,
      });
    },
    handleCashOpeningHistoryFiltered(response) {
      this.cashOpeningList = Array.isArray(response?.data) ? response.data : [];
      this.syncAdminManagedReopenFromHistory();
    },
    async selectCashOpening(item) {
      if (!item?.ID_CashOpening) {
        return;
      }

      this.selectedCashOpeningId = item.ID_CashOpening;
      try {
        const response = await this.$API.cashOpening.getOpeningSummary(item.ID_CashOpening);
        this.selectedCashOpeningSummary = response?.data || null;
      } catch (error) {
        console.error("selectCashOpening", error);
        this.selectedCashOpeningSummary = null;
        this.showAlert(
          this.invoiceDataErrorAlert,
          "warning",
          "No se pudo abrir el detalle",
          error?.response?.data?.message || error?.message || "No se pudo consultar el detalle de la caja."
        );
      }
    },
    async openCashOpeningDetailModal(item) {
      if (this.isCashOpeningActiveReopen(item) && this.isManagedActiveReopenByCurrentAdmin(item)) {
        this.cashOpeningDialogTargetOpeningId = this.getOpeningId(item);
        this.cashOpeningStatusOverride = this.normalizeCashOpeningForStatus(item);
        this.cashOpeningDialog = true;
        return;
      }

      if (!item?.ClosedAt) {
        return;
      }
      await this.selectCashOpening(item);
      this.cashOpeningDetailDialog = Boolean(this.selectedCashOpeningSummary);
    },
    async reopenSelectedCashOpening() {
      const selectedOpening = this.selectedCashOpeningSummary?.opening || null;
      const openingId = this.getOpeningId(selectedOpening);

      if (!openingId || !this.canReopenSelectedCashOpening) {
        return;
      }

      this.cashOpeningReopenLoading = true;
      try {
        await this.$API.cashOpening.reopenCash({
          OpeningId: openingId,
        });
        this.cashOpeningDialogTargetOpeningId = openingId;
        this.cashOpeningStatusOverride = this.normalizeCashOpeningForStatus(selectedOpening);
        await this.fetchCashOpeningStatus();
        await this.fetchCashOpeningHistory();
        await this.fetchCashControlRecords();
        await this.selectCashOpening({
          ID_CashOpening: openingId,
        });
        this.cashOpeningStatusOverride = this.normalizeCashOpeningForStatus(this.selectedCashOpeningSummary?.opening);
      } catch (error) {
        console.error("reopenSelectedCashOpening", error);
      } finally {
        this.cashOpeningReopenLoading = false;
      }
    },
    getOpeningId(opening = {}) {
      return opening?.ID_CashOpening
        || opening?.id
        || opening?.openingId
        || null;
    },
    getOpeningUserId(opening = {}) {
      return opening?.ID_User
        || opening?.userId
        || opening?.UserId
        || opening?.idUser
        || null;
    },
    getOpeningReopenedByUserId(opening = {}) {
      return opening?.ReopenedByUserId
        || opening?.reopenedByUserId
        || opening?.ReopenedBy
        || opening?.reopenedBy
        || null;
    },
    isCashOpeningClosed(opening = {}) {
      if (opening?.isClosed !== undefined && opening?.isClosed !== null) {
        return Boolean(opening.isClosed);
      }

      if (this.isCashOpeningActive(opening)) {
        return false;
      }

      return Boolean(opening?.ClosedAt || opening?.closedAt);
    },
    isCashOpeningActive(opening = {}) {
      if (opening?.isClosed !== undefined && opening?.isClosed !== null) {
        return !opening.isClosed;
      }

      const hasOpenCloseCycle = Boolean(opening?.ClosedAt || opening?.closedAt);
      const hasActiveReopen = (opening?.ReopenedAt || opening?.reopenedAt)
        && !(opening?.ReclosedAt || opening?.reclosedAt);

      return !hasOpenCloseCycle || hasActiveReopen;
    },
    isCashOpeningActiveReopen(opening = {}) {
      return Boolean(
        this.isCashOpeningActive(opening)
        && (opening?.ReopenedAt || opening?.reopenedAt)
      );
    },
    isManagedActiveReopenByCurrentAdmin(opening = {}) {
      if (!this.isAdminCashView || !this.isCashOpeningActiveReopen(opening)) {
        return false;
      }

      const reopenedByUserId = String(this.getOpeningReopenedByUserId(opening) || "").trim();
      return Boolean(reopenedByUserId && reopenedByUserId === this.currentInternalUserId);
    },
    syncAdminManagedReopenFromHistory() {
      if (!this.isAdminCashView) {
        return;
      }

      const managedReopen = this.cashOpeningList.find((item) => this.isManagedActiveReopenByCurrentAdmin(item)) || null;

      if (!managedReopen) {
        if (!this.cashOpeningStatus?.activeOpening) {
          this.cashOpeningStatusOverride = null;
          this.cashOpeningDialogTargetOpeningId = null;
        }
        return;
      }

      this.cashOpeningDialogTargetOpeningId = this.getOpeningId(managedReopen);
      this.cashOpeningStatusOverride = this.normalizeCashOpeningForStatus(managedReopen);
    },
    getCashOpeningStatusLabel(opening = {}) {
      if (this.isCashOpeningActiveReopen(opening)) {
        return "Reapertura activa";
      }

      if (this.isCashOpeningActive(opening)) {
        return "Abierta";
      }

      return opening?.ClosedAt || opening?.closedAt
        ? this.formatDate(opening?.ClosedAt || opening?.closedAt)
        : "Cerrada";
    },
    normalizeCashOpeningForStatus(opening = null) {
      if (!opening || typeof opening !== "object") {
        return null;
      }

      return {
        ...opening,
        ID_CashOpening: this.getOpeningId(opening),
        ID_User: this.getOpeningUserId(opening),
        FullName: opening?.FullName || opening?.fullName || opening?.UserName || opening?.userName || "",
        PointSale: opening?.PointSale || opening?.pointSale || null,
        OpenedAt: opening?.OpenedAt || opening?.openedAt || null,
        OpeningAmount: opening?.OpeningAmount ?? opening?.openingAmount ?? 0,
        ClosingAmount: opening?.ClosingAmount ?? opening?.closingAmount ?? null,
        DisplayOpeningId: this.getCashOpeningDisplayId(opening),
      };
    },
    getCashControlMovementTypeLabel(value) {
      if (String(value || "") === "OPENING_AMOUNT") {
        return "Fondo inicial";
      }
      const movementType = Number(value);
      if (movementType === 1) {
        return "Egreso";
      }
      if (movementType === 2) {
        return "Ingreso";
      }
      return String(value || "-");
    },
    getInternalUserName(userId) {
      if (!userId) {
        return "";
      }

      const user = this.adminCashOpeningUsers.find((item) => String(item.ID_User) === String(userId));
      return user?.FullName || user?.UserName || String(userId);
    },
    getCashControlUserLabel(control = {}) {
      return this.getInternalUserName(control.ID_User)
        || control.UserName
        || control.FullName
        || String(control.ID_User || "-");
    },
    getCashControlResponsibleLabel(control = {}) {
      return control.ExternalResponsible
        || this.getInternalUserName(control.InternalResponsibleUserId)
        || control.InternalResponsibleUserId
        || "-";
    },
    getCashControlApprovedByName(userId) {
      if (!userId) {
        const currentUser = this.getCurrentUser();
        const fullName = `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim();
        return fullName || currentUser.username || currentUser.ID_User || "";
      }

      const internalUserName = this.getInternalUserName(userId);
      if (internalUserName && internalUserName !== String(userId)) {
        return internalUserName;
      }

      const currentUser = this.getCurrentUser();
      if (String(userId) === String(currentUser.id || currentUser.ID_User || "")) {
        const fullName = `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim();
        return fullName || currentUser.username || userId;
      }

      return String(userId);
    },
    async printCashControlRecord(controlRecord) {
      if (!controlRecord) {
        return;
      }

      const { jsPDF } = await import("jspdf");
      const doc = new jsPDF({
        unit: "mm",
        format: "letter",
      });

      const copyLabels = ["Original", "Copia 1", "Copia 2"];
      const movementTypeText = Number(controlRecord.MovementType) === 1 ? "Egreso" : "Ingreso";
      const internalResponsible = this.getInternalUserName(controlRecord.InternalResponsibleUserId) || "-";
      const currentUser = this.getCurrentUser();
      const pointSale = this.getCurrentPointSale() || currentUser.pointsale || "-";
      const amount = this.formatAmount(controlRecord.Amount);
      const createdAt = this.formatDate(controlRecord.CreatedAt || new Date());
      const approvedByName = this.getCashControlApprovedByName(controlRecord.ID_User) || "-";
      const openingId = controlRecord.ID_CashOpening || "-";
      const payee = internalResponsible !== "-" ? internalResponsible : (controlRecord.ExternalResponsible || "-");

      const borderColor = [45, 48, 54];
      const copyHeight = 68;
      const copyGap = 22;
      const baseX = 8;
      const baseY = 10;
      const totalWidth = 200;

      const drawLineField = (label, value, x, y, lineWidth) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(35, 35, 35);
        doc.text(`${label}:`, x, y);
        doc.line(x + 22, y + 1, x + lineWidth, y + 1);
        if (value) {
          const text = doc.splitTextToSize(String(value), lineWidth - 26);
          doc.text(text[0], x + 24, y);
        }
      };

      copyLabels.forEach((copyLabel, index) => {
        const top = baseY + (index * (copyHeight + copyGap));

        doc.setDrawColor(...borderColor);
        doc.setLineWidth(0.5);
        doc.roundedRect(baseX, top, totalWidth, copyHeight, 4, 4);

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(16);
        doc.text("VALE DE CAJA CHICA", baseX + 6, top + 8);
        doc.setFontSize(9.5);
        doc.text(`FECHA: ${createdAt}`, baseX + 6, top + 16);

        doc.roundedRect(baseX + 150, top + 1.5, 44, 10, 2, 2);
        doc.setFontSize(12);
        doc.text("$", baseX + 153, top + 8.5);
        doc.text(`${amount}`, baseX + 190, top + 8.5, { align: "right" });
        doc.setFontSize(8);
        doc.text(copyLabel.toUpperCase(), baseX + 172, top + 15.5, { align: "center" });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10.5);
        doc.text(movementTypeText.toUpperCase(), baseX + 6, top + 24);

        drawLineField("Paguese a", payee, baseX + 6, top + 32, 186);
        drawLineField("Por concepto de", controlRecord.Detail || "-", baseX + 6, top + 42, 186);
        drawLineField("", "", baseX + 6, top + 52, 186);

        doc.line(baseX + 2, top + 58, baseX + 198, top + 58);
        doc.line(baseX + 34, top + 58, baseX + 34, top + 68);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(7.2);
        doc.text("CUENTA No.", baseX + 4, top + 62);
        doc.text("APROBADO POR", baseX + 47, top + 62);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(7.8);
        doc.text(`${openingId}`, baseX + 4, top + 67);
        doc.text(`${approvedByName}  |  PV ${pointSale}`, baseX + 47, top + 67);

        const signatureTop = top + copyHeight + 10;
        doc.line(baseX + 16, signatureTop, baseX + 82, signatureTop);
        doc.line(baseX + 126, signatureTop, baseX + 192, signatureTop);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text("ENTREGA", baseX + 49, signatureTop + 4.5, { align: "center" });
        doc.text("RECIBE", baseX + 159, signatureTop + 4.5, { align: "center" });

        if (index < copyLabels.length - 1) {
          const cutLineY = top + copyHeight + copyGap - 4;
          doc.setDrawColor(120, 120, 120);
          doc.setLineWidth(0.2);
          doc.setLineDashPattern([1.5, 1.5], 0);
          doc.line(baseX, cutLineY, baseX + totalWidth, cutLineY);
          doc.setLineDashPattern([], 0);
          doc.setDrawColor(...borderColor);
        }
      });

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
    },
    ensurePdfPageSpace(doc, cursorY, requiredHeight = 120, marginTop = 36) {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (cursorY + requiredHeight > pageHeight - 36) {
        doc.addPage();
        return marginTop;
      }
      return cursorY;
    },
    buildCashOpeningPdfTitleSuffix() {
      const selectedUserFilter = this.cashOpeningHistoryAdvancedFilters.find((item) => item.name === "cashOpeningUserId");
      const userLabel = selectedUserFilter?.options?.find((item) => String(item.value || "") === String(selectedUserFilter.value || ""))?.name || "Todos";
      const startDate = this.cashOpeningHistoryAdvancedFilters.find((item) => item.name === "cashOpeningStartDate")?.value || null;
      const endDate = this.cashOpeningHistoryAdvancedFilters.find((item) => item.name === "cashOpeningEndDate")?.value || null;
      const parts = [];

      if (startDate || endDate) {
        parts.push(`Rango: ${startDate || "-"} a ${endDate || "-"}`);
      }

      if (this.isAdminCashView) {
        parts.push(`Usuario: ${userLabel || "Todos"}`);
      }

      if (this.cashOpeningHistorySearch.filter) {
        parts.push(`Busqueda: ${this.cashOpeningHistorySearch.filter}`);
      }

      return parts.join(" | ");
    },
    drawCashOpeningSummaryPdfSection(doc, autoTable, summary, options = {}) {
      const marginLeft = options.marginLeft || 36;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      let cursorY = options.cursorY || 36;
      const tableLineColor = [110, 110, 110];
      const closingMovements = summary.closingMovements || [];
      const filteredArqueoRows = this.getFilteredArqueoRows(summary.arqueoRows || []);
      const controls = summary.controls || [];
      const closingMovementsTotal = closingMovements.reduce((sum, item) => sum + Number(item.amount || 0), 0);
      const arqueoTotals = filteredArqueoRows.reduce((totals, item) => ({
        appAmount: totals.appAmount + Number(item.appAmount || 0),
        userAmount: totals.userAmount + Number(item.userAmount || 0),
        differenceAmount: totals.differenceAmount + Number(item.differenceAmount || 0),
      }), {
        appAmount: 0,
        userAmount: 0,
        differenceAmount: 0,
      });

      if (options.sectionTitle) {
        cursorY = this.ensurePdfPageSpace(doc, cursorY, 40, marginLeft);
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        doc.text(options.sectionTitle, marginLeft, cursorY);
        cursorY += 18;
      }

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      cursorY = this.ensurePdfPageSpace(doc, cursorY, 72, marginLeft);
      const rightColumnX = pageWidth / 2 + 10;
      const metaLineHeight = 20;
      const openingMetaRows = [
        [
          `Usuario: ${summary.opening.fullName || ""}`,
          `No. apertura: ${this.getCashOpeningDisplayId(summary.opening) || ""}`,
        ],
        [
          `Apertura: ${this.formatDate(summary.opening.openedAt)}`,
          `Cierre: ${summary.opening.closedAt ? this.formatDate(summary.opening.closedAt) : "Pendiente"}`,
        ],
        [
          `Fondo inicial: ${this.formatAmount(summary.opening.openingAmount)}`,
          `Monto cierre: ${summary.opening.closingAmount === null ? "Pendiente" : this.formatAmount(summary.opening.closingAmount)}`,
        ],
        [
          `Punto de venta: ${summary.opening.pointSale || "Sin definir"}`,
          "",
        ],
      ];

      openingMetaRows.forEach((row) => {
        doc.text(row[0], marginLeft, cursorY);
        if (row[1]) {
          doc.text(row[1], rightColumnX, cursorY);
        }
        cursorY += metaLineHeight;
      });

      cursorY += 6;
      cursorY = this.ensurePdfPageSpace(doc, cursorY, 120, marginLeft);
      doc.setFont(undefined, "bold");
      doc.text("Totales de cierre", marginLeft, cursorY);
      cursorY += 8;

      autoTable(doc, {
        startY: cursorY,
        margin: { left: marginLeft, right: marginLeft },
        head: [["Detalle", "Monto"]],
        body: closingMovements.length
          ? [
              ...closingMovements.map((item) => [
                item.detail || "",
                this.formatAmount(item.amount),
              ]),
              ["Total", this.formatAmount(closingMovementsTotal)],
            ]
          : [["Sin datos", ""]],
        styles: {
          fontSize: 9,
          cellPadding: 4,
          lineColor: tableLineColor,
          lineWidth: 0.35,
          fillColor: false,
        },
        bodyStyles: {
          fillColor: false,
        },
        alternateRowStyles: {
          fillColor: false,
        },
        headStyles: {
          fillColor: false,
          textColor: 20,
          fontStyle: "bold",
          lineColor: tableLineColor,
          lineWidth: 0.35,
        },
        columnStyles: {
          1: { halign: "right" },
        },
      });

      cursorY = doc.lastAutoTable.finalY + 18;
      cursorY = this.ensurePdfPageSpace(doc, cursorY, 140, marginLeft);
      doc.setFont(undefined, "bold");
      doc.text("Arqueo de caja", marginLeft, cursorY);
      cursorY += 8;

      autoTable(doc, {
        startY: cursorY,
        margin: { left: marginLeft, right: marginLeft },
        head: [["Forma de pago", "Monto calculado", "Monto usuario", "Diferencia"]],
        body: filteredArqueoRows.length
          ? [
              ...filteredArqueoRows.map((item) => [
                item.paymentMethod || "",
                this.formatAmount(item.appAmount),
                item.userAmount === null || item.userAmount === undefined ? "-" : this.formatAmount(item.userAmount),
                item.differenceAmount === null || item.differenceAmount === undefined ? "-" : this.formatAmount(item.differenceAmount),
              ]),
              [
                "Total",
                this.formatAmount(arqueoTotals.appAmount),
                this.formatAmount(arqueoTotals.userAmount),
                this.formatAmount(arqueoTotals.differenceAmount),
              ],
            ]
          : [["", "Sin datos", "", ""]],
        styles: {
          fontSize: 9,
          cellPadding: 4,
          lineColor: tableLineColor,
          lineWidth: 0.35,
          fillColor: false,
        },
        bodyStyles: {
          fillColor: false,
        },
        alternateRowStyles: {
          fillColor: false,
        },
        headStyles: {
          fillColor: false,
          textColor: 20,
          fontStyle: "bold",
          lineColor: tableLineColor,
          lineWidth: 0.35,
        },
        columnStyles: {
          1: { halign: "right" },
          2: { halign: "right" },
          3: { halign: "right" },
        },
      });

      cursorY = doc.lastAutoTable.finalY + 18;
      cursorY = this.ensurePdfPageSpace(doc, cursorY, 140, marginLeft);
      doc.setFont(undefined, "bold");
      doc.text("Caja chica y registros", marginLeft, cursorY);
      cursorY += 8;

      autoTable(doc, {
        startY: cursorY,
        margin: { left: marginLeft, right: marginLeft },
        head: [["Fecha", "Tipo", "Detalle", "Monto", "Responsable"]],
        body: controls.length
          ? controls.map((item) => [
              item.createdAt ? this.formatDate(item.createdAt) : "-",
              this.getCashControlMovementTypeLabel(item.movementType),
              item.detail || "-",
              this.formatAmount(item.amount),
              item.externalResponsible || item.internalResponsibleUserId || "-",
            ])
          : [["-", "-", "Sin registros", "-", "-"]],
        styles: {
          fontSize: 8.5,
          cellPadding: 4,
          lineColor: tableLineColor,
          lineWidth: 0.35,
          fillColor: false,
        },
        bodyStyles: {
          fillColor: false,
        },
        alternateRowStyles: {
          fillColor: false,
        },
        headStyles: {
          fillColor: false,
          textColor: 20,
          fontStyle: "bold",
          lineColor: tableLineColor,
          lineWidth: 0.35,
        },
        columnStyles: {
          3: { halign: "right" },
        },
      });

      cursorY = doc.lastAutoTable.finalY + 18;

      if (cursorY > pageHeight - 60) {
        doc.addPage();
        cursorY = marginLeft;
      }

      return cursorY;
    },
    async printSelectedCashOpeningSummary() {
      if (!this.selectedCashOpeningSummary) {
        return;
      }

      const jsPDF = (await import("jspdf")).jsPDF || (await import("jspdf")).default;
      const autoTable = (await import("jspdf-autotable")).default;
      const summary = this.selectedCashOpeningSummary;
      const businessName = JSON.parse(localStorage.getItem("user"))?.business || "Innova";
      const doc = new jsPDF("p", "pt", "letter");
      const marginLeft = 36;
      const pageWidth = doc.internal.pageSize.getWidth();
      let cursorY = 36;

      doc.setFontSize(14);
      doc.setFont(undefined, "bold");
      doc.text(businessName, pageWidth / 2, cursorY, { align: "center" });
      cursorY += 18;

      doc.setFontSize(13);
      doc.text("Reporte de cierre de caja", pageWidth / 2, cursorY, { align: "center" });
      cursorY += 24;
      cursorY = this.drawCashOpeningSummaryPdfSection(doc, autoTable, summary, {
        cursorY,
        marginLeft,
      });

      const safeUser = String(summary.opening.userId || "usuario").replace(/[^\w-]/g, "_");
      const safeOpening = String(this.getCashOpeningDisplayId(summary.opening) || summary.opening.id || "apertura").replace(/[^\w-]/g, "_");
      doc.save(`CierreCaja_${safeUser}_${safeOpening}.pdf`);
    },
    async printFilteredCashOpeningSummaries() {
      if (!this.cashOpeningList.length) {
        return;
      }

      this.cashOpeningBulkPrintLoading = true;
      try {
        const jsPDF = (await import("jspdf")).jsPDF || (await import("jspdf")).default;
        const autoTable = (await import("jspdf-autotable")).default;
        const businessName = JSON.parse(localStorage.getItem("user"))?.business || "Innova";
        const doc = new jsPDF("p", "pt", "letter");
        const marginLeft = 36;
        const pageWidth = doc.internal.pageSize.getWidth();
        let cursorY = 36;
        const titleSuffix = this.buildCashOpeningPdfTitleSuffix();

        const filteredOpenings = [...this.cashOpeningList].sort((left, right) => {
          const leftUser = String(left.FullName || left.UserName || "").toLowerCase();
          const rightUser = String(right.FullName || right.UserName || "").toLowerCase();
          if (leftUser !== rightUser) {
            return leftUser.localeCompare(rightUser);
          }

          return new Date(right.OpenedAt).getTime() - new Date(left.OpenedAt).getTime();
        });

        const results = await Promise.allSettled(
          filteredOpenings.map((item) => this.$API.cashOpening.getOpeningSummary(item.ID_CashOpening))
        );

        const summaries = results
          .map((result, index) => ({
            opening: filteredOpenings[index],
            response: result.status === "fulfilled" ? result.value : null,
          }))
          .filter((item) => item.response?.data);

        if (!summaries.length) {
          return;
        }

        doc.setFontSize(14);
        doc.setFont(undefined, "bold");
        doc.text(businessName, pageWidth / 2, cursorY, { align: "center" });
        cursorY += 18;

        doc.setFontSize(13);
        doc.text("Reporte consolidado de cierres de caja", pageWidth / 2, cursorY, { align: "center" });
        cursorY += 18;

        if (titleSuffix) {
          doc.setFont(undefined, "normal");
          doc.setFontSize(9);
          doc.text(titleSuffix, pageWidth / 2, cursorY, { align: "center" });
          cursorY += 24;
        } else {
          cursorY += 10;
        }

        let currentUserKey = "";
        summaries.forEach((item, index) => {
          const summary = item.response.data;
          const userKey = String(summary.opening.fullName || summary.opening.userId || "");

          if (index > 0) {
            doc.addPage();
            cursorY = marginLeft;
          }

          if (userKey !== currentUserKey) {
            currentUserKey = userKey;
            doc.setFont(undefined, "bold");
            doc.setFontSize(12);
            doc.text(`Usuario: ${currentUserKey}`, marginLeft, cursorY);
            cursorY += 18;
          }

          cursorY = this.drawCashOpeningSummaryPdfSection(doc, autoTable, summary, {
            cursorY,
            marginLeft,
            sectionTitle: `Corte #${this.getCashOpeningDisplayId(summary.opening) || item.opening.DisplayOpeningId || item.opening.ID_CashOpening}`,
          });
        });

        doc.save(`CierresCaja_Filtrados_${new Date().toISOString().slice(0, 10)}.pdf`);
      } catch (error) {
        console.error("printFilteredCashOpeningSummaries", error);
      } finally {
        this.cashOpeningBulkPrintLoading = false;
      }
    },
    getFilteredArqueoRows(rows = []) {
      if (!this.hideZeroAmountPaymentMethods) {
        return rows;
      }

      return rows.filter((item) => !this.isZeroAmountArqueoRow(item));
    },
    isZeroAmountArqueoRow(item = {}) {
      const appAmount = Number(item.appAmount || 0);
      const userAmount = item.userAmount === null || item.userAmount === undefined
        ? 0
        : Number(item.userAmount || 0);

      return appAmount === 0 && userAmount === 0;
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleString();
    },
    formatAmount(value) {
      const amount = Number(value || 0);
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getCashOpeningDisplayId(opening = {}) {
      return opening?.DisplayOpeningId
        || opening?.displayOpeningId
        || opening?.correlativeId
        || opening?.CorrelativeIdApertura
        || opening?.Correlative_ID_apertura
        || opening?.ID_CashOpening
        || opening?.id
        || opening?.openingId
        || null;
    },
    onShowAllRows(e) {
      this.loading = true;
      this.$nextTick(() => {
        this.showRowDate = !e;
      });
      this.loading = false;
    },
    async loadData(tab) {
      if (tab === "1" && !this.firstLoadTabs[tab]) {
        if (!this.cashierCutUsers.length) {
          await this.fetchAdminCashOpeningUsers();
        }
        await this.getCashierCut();
        this.firstLoadTabs[tab] = true
      } else if (tab === "2" && !this.firstLoadTabs[tab]) {
        if (!this.cashierCutUsers.length) {
          await this.fetchAdminCashOpeningUsers();
        }
        await this.getCashierCutDetails();
        this.firstLoadTabs[tab] = true
      } else if (tab === "3") {
        if (!this.cashierCutUsers.length) {
          await this.fetchAdminCashOpeningUsers();
        }
        await this.fetchCashOpeningStatus();
        await this.fetchCashOpeningHistory();
        await this.fetchCashControlRecords();
      }
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    setDates(dates) {
      this.dates = {
        ...this.dates,
        ...dates,
        typeData: this.dates.typeData,
        typeDate: this.dates.typeDate,
      };
    },
    setDates2(dates) {
      this.dates2 = {
        ...this.dates2,
        ...dates,
        typeData: this.dates2.typeData,
        typeDate: this.dates2.typeDate,
      };
    },
    printReport() {
      this.print.show = true;
      this.print.data.body = this.cashierCut;
      this.print.data.dates = Object.assign({}, this.dates);
      if (isNaN(this.print.footer.tsales)) {
        const currenTcheff = this.print.footer.ting - this.print.footer.vbot;
        this.print.footer = {
          tsales:
            this.Currency +
              " " +
              numberWithCommas(this.print.footer.tsales.toFixed(2)) || 0.0,
          tcredit:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.tcredit.toFixed(2)),
          tdev:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.tdev.toFixed(2)),
          tsalesCredit:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.tsalesCredit.toFixed(2)),
          ting:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.ting.toFixed(2)),
          vbot:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.vbot.toFixed(2)),
          abt:
            this.Currency +
            " " +
            numberWithCommas(this.print.footer.abt.toFixed(2)),
          tcheef:
            this.Currency + " " + numberWithCommas(currenTcheff.toFixed(2)),
        };
      }
      this.print.header.title = "Corte de caja";
      this.print.header.cutDate = ` ${this.dates.start} - ${this.dates.end}`;
      this.printList.push({ component: PrintCutBox, data: this.print });
    },
    onExporting(e) {
      printToExcel(e, "Corte de caja");
    },
    setInvoiceType(inv) {
      switch (inv) {
        case "FCF":
          return "CONSUMIDOR FINAL";
        case "CCF":
          return "CRÉDITO FISCAL";
        case "FNS":
          return "SUJETO EXCLUIDO";
        case "FEX":
          return "EXPORTACIÓN";
        case "DNC":
          return "NOTA DE CRÉDITO";
        case "DND":
          return "NOTA DE DÉBITO";
        default:
          return "Tipo de factura desconocido";
      }
    },
    setupData(data) {
      this.print.footer = {
        tsales: 0,
        tcredit: 0,
        tdev: 0,
        tsalesCredit: 0,
        ting: 0,
        vbot: 0,
        abt: 0,
        tcheef: 0,
      };

      return data.map((item) => {
        if (
          item.InvoiceType === "CCF" ||
          item.InvoiceType === "FCF" ||
          item.InvoiceType === "FEX"
        ) {
          this.print.footer.tsales += parseFloat(item.TotalSale);
        }
        if (item.InvoiceType === "FCF" || item.InvoiceType === "DNC") {
          this.print.footer.tsalesCredit += parseFloat(item.TotalSale);
        }

        if (
          (item.InvoiceType === "CCF" ||
            item.InvoiceType === "FCF" ||
            item.InvoiceType === "FEX") &&
          (item.InvoicePaymentType == "Billetes y monedas" ||
            item.InvoicePaymentType == "Cheque")
        ) {
          this.print.footer.ting += parseFloat(item.TotalSale);
        } else if (
          (item.InvoiceType === "CCF" ||
            item.InvoiceType === "FCF" ||
            item.InvoiceType === "FEX") &&
          item.InvoicePaymentType != "Billetes y monedas" &&
          item.InvoicePaymentType != "Cheque"
        ) {
          this.print.footer.vbot += parseFloat(item.TotalSale);
        }

        return {
          ...item,
          InvoiceType: this.setInvoiceType(item.InvoiceType),
          InvoiceTotalGravada:
            this.Currency + " " + item.InvoiceTotalGravada.toFixed(2),
          InvoiceIvaRete1:
            this.Currency + " " + item.InvoiceIvaRete1.toFixed(2),
          InvoiceTotalIva:
            this.Currency + " " + item.InvoiceTotalIva.toFixed(2),
        };
      });
    },
    getValidCutDataDetails(data) {
      const validData = []
      const invalidData = []
      
      data.forEach((item) => {
        if (!item.ID_Invoice) {
          console.log("Warning: Invalid or missing Invoice ID", item);
          invalidData.push("Missing Invoice ID");
          return
        }  
        validData.push(item)
      })

      if (invalidData.length > 0) {
        if (!this.invoiceDataErrorAlert.seen) {
          // if theres any invalid data and the alert has not been shown, show the alert
          this.showAlert(
            this.invoiceDataErrorAlert, 
            "warning", 
            "Advertencia", 
            `Uno o más registros presentan campos inválidos o faltantes. Por favor, comunicarse 
            con el Contact Center. Errores: ${invalidData.join(", ")}`,
            { seen: true });
        }
      }

      return validData
    },
    checkCutDataDetails(data) {
      this.invoiceDataErrorAlert = {
        ...this.invoiceDataErrorAlert,
        seen: false,
      }
      this.getValidCutDataDetails(data)
    },
    getCashierCut() {
      this.loading = true;
      return this.$API.invoices.getCashierCut(this.dates)
        .then((response) => {
          const records = Array.isArray(response) ? response : [];

          if (!records.length) {
            this.cashierCut = [];
            Object.assign(this, this.buildCashierCutTotalsState([], true));
            return;
          }

          this.cashierCut = this.reportModule ? this.setupData(records) : records;
          Object.assign(this, this.buildCashierCutTotalsState(this.cashierCut, true));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCashierCutDetails() {
      this.print2 = {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      };

      this.loading = true;
      return this.$API.invoices.getCashierCutDetails(this.dates2)
        .then((response) => {
          const records = Array.isArray(response) ? response : [];
          const validRecords = this.getValidCutDataDetails(records);

          if (!records.length) {
            this.cashierCutDetails = [];
            Object.assign(this, this.buildCashierCutTotalsState([], false));
            return;
          }

          this.cashierCutDetails = validRecords;
          Object.assign(this, this.buildCashierCutTotalsState(validRecords, false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterHandler(response) {
      if (this.reportModule) {
        this.cashierCut = this.setupData(response);
        Object.assign(this, this.buildCashierCutTotalsState(this.cashierCut, true));
      } else {
        this.cashierCut = response;
        Object.assign(this, this.buildCashierCutTotalsState(this.cashierCut, true));
      }
      this.loading = false;
    },
    filterHandler2(response) {
      this.print2 = {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      };

      const validRecords = this.getValidCutDataDetails(response);
      this.cashierCutDetails = validRecords;
      Object.assign(this, this.buildCashierCutTotalsState(validRecords, false));
      this.loading = false;
    },
    dateFilterHandler(filteredData) {
      if (this.reportModule) {
        this.cashierCut = this.setupData(filteredData);
        Object.assign(this, this.buildCashierCutTotalsState(this.cashierCut, true));
      } else {
        this.cashierCut = filteredData;
        Object.assign(this, this.buildCashierCutTotalsState(this.cashierCut, true));
      }
      this.loading = false;
    },
    dateFilterHandler2(filteredData) {
      this.print2 = {
        show: false,
        header: {},
        data: {
          body: [],
        },
        footer: {},
      };

      const validRecords = this.getValidCutDataDetails(filteredData);
      this.cashierCutDetails = validRecords;
      Object.assign(this, this.buildCashierCutTotalsState(validRecords, false));
      this.loading = false;
    },
    getCustomCell(rowData) {
      return ` ${rowData.FormattedDate} - Tipo de pago: ${rowData.DescPaymentType} - Estado: ${rowData.InvoiceStatusDescription} - Usuario: ${rowData.FullName} - Total: ${rowData.TotalGlobal}`;
    },
    onExporting2(e) {
      printToExcel(e, "Reporte corte de caja detallado");
    },
    showAlert(alertObj, type, header, body, options = null) {
        type = type == null ? "danger" : type;
        alertObj.type = type;
        alertObj.header = header;
      alertObj.body = body;
      alertObj.show = true;
      alertObj.options = options != null ? options : null;
      alertObj = { ...alertObj}
      console.log(alertObj)  
    },
    closeAlert(alertObj) {
        alertObj.show = false;
        alertObj.seen = true; // Mark the alert as seen
        alertObj = { ...alertObj}
    },
    acceptAlert(alertObj) {
        alertObj.show = false;
        alertObj.seen = true; // Mark the alert as seen
        alertObj = { ...alertObj}
    },
    printCashierCutDetailsPDF() {
      printCashierCutPDF(this.cashierCutDetails, this.dates2)
    },
  },
};
</script>

<style scoped>
.btn-add {
  background-color: #3498db !important;
  color: white;
}

.btn-color-white {
  color: white;
}

.cashier-cut-date-filter {
  width: 100%;
  padding-top: 0 !important;
}

.cashier-cut-filter-row {
  max-width: 100%;
  width: 100%;
}

@media screen and (max-width: 900px) {
  .cashier-cut-date-filter {
    padding-bottom: 20px;
  }
}

@media screen and (min-width: 961px) {
  .cashier-cut-date-filter {
    flex-wrap: nowrap !important;
  }
}

.cash-close-grid {
  row-gap: 14px;
}

.cash-close-card {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.cash-close-card--header {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.cash-close-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
}

.cash-close-header__summary {
  flex: 1 1 auto;
  min-width: 0;
}

.cash-close-header__meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px 18px;
}

.cash-close-header__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cash-close-header__label {
  font-size: 12px;
  line-height: 1.2;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cash-close-header__value {
  font-size: 15px;
  line-height: 1.35;
  color: #0f172a;
  font-weight: 600;
}

.cash-close-header__actions {
  flex: 0 0 320px;
  max-width: 320px;
}

.cash-close-header__buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.cash-close-card--full {
  min-height: 100%;
}

.cash-close-tab-panel {
  padding-top: 18px;
}

.cash-opening-detail-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cash-opening-detail-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cash-close-tabs::v-deep .v-slide-group__content {
  gap: 18px;
}

@media screen and (max-width: 960px) {
  .cash-close-header {
    flex-direction: column;
  }

  .cash-close-header__actions {
    flex: 1 1 auto;
    max-width: none;
    width: 100%;
  }

  .cash-opening-detail-toolbar,
  .cash-opening-detail-toolbar__actions {
    align-items: stretch;
  }
}
</style>
